import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../../errors/responses';
import { Company } from '../companies';
import { AdditionalStock } from './additionalStock';
import { BundleWeighting } from './weighting';

const c = initContract();

export const StockLevel = z.object({
  id: z.string(),
  employeeCount: z.number(),
  churnRate: z.number(),
  growthRate: z.number(),
  stockLevelState: z.number(),
  customer: Company,
  bundleWeightings: z.array(BundleWeighting),
  additionalBundleStocks: z.array(AdditionalStock),
  additionalGeneralStocks: z.array(AdditionalStock)
});

export type StockLevel = z.infer<typeof StockLevel>;

const StockLevelRequest = z.object({
  employeeCount: z.number(),
  churnRate: z.number(),
  growthRate: z.number(),
  stockLevelState: z.number()
});

export default c.router({
  getStockLevels: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/stocklevels',
    responses: {
      200: z.object({
        items: z.array(StockLevel)
      }),
      ...failedResponses
    }
  },
  getStockLevel: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/stocklevels/:id',
    responses: {
      200: StockLevel,
      ...failedResponses
    }
  },
  createStockLevel: {
    method: 'POST',
    path: '/msp/:mspId/customers/:customerId/stocklevels',
    responses: {
      200: StockLevel,
      ...failedResponses
    },
    body: StockLevelRequest
  },
  updateStockLevel: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/stocklevels/:id',
    responses: {
      200: StockLevel,
      ...failedResponses
    },
    body: StockLevelRequest
  },
  deleteStockLevel: {
    method: 'DELETE',
    path: '/msp/:mspId/customers/:customerId/stocklevels/:id',
    responses: {
      200: z.undefined(),
      ...failedResponses
    },
    body: z.undefined()
  },
  updateStockLevelStatus: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/stocklevels/:id/state',
    responses: {
      200: z.undefined(),
      ...failedResponses
    },
    body: z.object({
      state: z.number()
    })
  }
});
